import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ArtImage } from "./ArtImage";

export const PageHero = ({ slug, children, testId }) => {
  const [art, setArt] = useState(null);

  useEffect(() => {
    if (!slug) return;
    api.get("/artworks").then((r) => setArt(r.data.find((a) => a.slug === slug) || null)).catch(() => {});
  }, [slug]);

  return (
    <div className="relative overflow-hidden px-5 sm:px-8 pt-32 sm:pt-32 pb-10 sm:pb-14" data-testid={testId}>
      {art && (
        <>
          <ArtImage
            art={art}
            size="lg"
            eager
            sizes="100vw"
            className="absolute inset-0 w-full h-full object-cover object-center opacity-30"
            testId={testId ? `${testId}-bg` : undefined}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/55 to-ink" />
        </>
      )}
      <div className="relative">{children}</div>
    </div>
  );
};
